import React, { useEffect, useRef, useState } from "react";

export default function Timer(props) {
  console.log("props Time", props);

  let Start = new Date(props.startTime);

  let StartDBTime = Start.getTime();
  let EndTime = new Date(props.endTime).getTime();

  let totalSeconds = EndTime - StartDBTime;

  var CurrentTime = new Date().getTime();

  let timeleft = EndTime - CurrentTime;


  console.log("timeleft",timeleft)
  console.log("totalSeconds",totalSeconds)

  let remaingTime = totalSeconds - timeleft;

  console.log("remaingTime", remaingTime);


  let remain = Math.ceil(timeleft / 1000);

  console.log("CurrentTime", CurrentTime);

  const [time, setTime] = useState(remain);
  const interval = useRef();
  useEffect(() => {
    interval.current = setInterval(() => {
      setTime((time) => {
        return time - 1;
      });
    }, 1000);
  }, []);
  useEffect(() => {
    // console.log(time, "fgjhkljhg", remain);

    if (time <= 0 && interval.current) {
      console.log("stopping time");
      clearInterval(interval.current);
    }
  }, [time]);
  // console.log("timer", time);

  return time >= 0 ? (
    <div>
      <p>
        {parseInt(`${Math.floor(time / 3600)}`.padStart(2, 0))} Hours,{" "}
        {parseInt(`${Math.floor((time % 3600) / 60)}`.padStart(2, 0))} Minutes,{" "}
        {parseInt(`${time % 60}`.padStart(2, 0))} Seconds
      </p>
    </div>
  ) : (
    "Time Expire"
  );
}
